// removed by extract-text-webpack-plugin
module.exports = {"logogramCard":"BrandLogogramScreen_logogramCard_2IivS"};